import { MessageCircle } from "lucide-react";
import { COMPANY } from "@/lib/constants";
import { useVisitorTracking } from "@/hooks/useVisitorTracking";
import { useLocation } from "react-router-dom";

const FloatingChatButton = () => {
  const { trackCTAClick } = useVisitorTracking();
  const location = useLocation();
  const isGA = location.pathname.startsWith("/roofing/ga") || location.pathname.startsWith("/roofing/georgia") || location.pathname.startsWith("/georgia-");
  const phoneNumber = isGA ? COMPANY.gaPhone.replace(/-/g, '') : COMPANY.phone.replace(/-/g, '');
  const smsHref = `sms:+1${phoneNumber}?body=${encodeURIComponent("Hi, I'd like a free roofing estimate.")}`;

  return (
    <a
      href={smsHref}
      onClick={() => trackCTAClick('FloatingText', 'floating_chat')}
      className="fixed bottom-20 right-4 md:bottom-6 md:right-6 z-50 w-14 h-14 rounded-full bg-accent text-accent-foreground shadow-lg hover:shadow-xl flex items-center justify-center transition-all hover:scale-110 active:scale-95"
      aria-label="Text us for a free estimate"
    >
      <MessageCircle className="w-6 h-6" />
    </a>
  );
};

export default FloatingChatButton;
